<!-- 由 suu 创建于 2025-06-27 星期五 -->
<template>
  <div class="CourseCancelPop" v-if="popType && showPop">
    <van-overlay :show="true" z-index="100" height="auto">
      <div class="pop-wrap">
        <div class="pop-title">确定要取消吗？</div>
        <div class="pop-cent" v-if="popType === 1"
          >本次取消在约课后<span class="red-text">10分钟内</span
          >，不会扣除经验值</div
        >
        <div class="pop-cent" v-if="popType === 2"
          >为了帮助您养成良好的运动习惯，当您临时取消课程时，我们会扣除相应的经验值：<span
            class="bold-text"
            >上课前2小时以内取消课程<span class="red-text">扣除20</span></span
          ></div
        >
        <div class="pop-cent" v-if="popType === 3"
          >为了帮助您养成良好的运动习惯，当您临时取消课程时，我们会扣除相应的经验值：<span
            class="bold-text"
            >上课前2小时-4小时取消课程<span class="red-text">扣除5</span></span
          ></div
        >
        <div class="pop-cent pop-cent-center" v-if="popType === 4"
          >现在取消课程，不会扣除经验值</div
        >
        <div class="pop-cent pop-cent-center" v-if="popType === 5"
          >现在取消课程，根据距离上课时间不同，我们可能会扣除经验值</div
        >
        <div class="pop-btn-wrap">
          <div class="pop-btn-off user-btn" @click.stop="handleCancel"
            >再想想</div
          >
          <div class="pop-btn user-btn" @click.stop="handleConfirm">确定</div>
        </div>
      </div>
    </van-overlay>
  </div>
</template>

<script>
export default {
  name: 'CourseCancelPop',

  components: {},

  props: {
    classInfo: {
      type: Object,
      default: () => {}
    }
  },

  data() {
    return {
      showPop: true,
      popType: 0 // 1: 10分钟内 2: 距离上课时间2小时以内 3: 距离上课时间2小时以上 4: 本次取消在上课 前4小时 5: 兜底
    }
  },

  computed: {},

  watch: {},

  created() {
    try {
      this.getCancelPopText()
    } catch (error) {
      this.$http.get('member/index?a=shareLogPush', {
        from: `扫码取消约课失败-created-${error && error.message}`,
        from_id: 250702345
      })
      this.popType = 5
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    handleCancel() {
      this.$emit('on-close')
    },
    /**
     * 获取日历日程列表并找到当前取消的课程的日程id
     */
    async calendarChannelMethod() {
      const version = await this.$betterwe.getAppVersion().catch(() => {})
      // 兼容两种数据结构：s_time/e_time 或 start_time/end_time
      const startTime = this.classInfo.s_time || this.classInfo.start_time
      const endTime = this.classInfo.e_time || this.classInfo.end_time
      if (version >= 270) {
        this.$betterwe.deleteGymCourseCalendarEvent(startTime, endTime)
      } else {
        const list = await this.$betterwe.getCalendarList()
        console.log('====================================')
        console.log('listlist', list, this.classInfo)
        console.log('====================================')
        if (list?.length && this.classInfo?.courseid) {
          const targetItemList = list.filter(
            (item) => item.name === this._formatTime(startTime, endTime)
          )
          console.log('====================================')
          console.log('targetItemList', targetItemList)
          console.log('====================================')
          if (targetItemList?.length) {
            targetItemList.map((v) => {
              try {
                this.$betterwe.deleteCalendar(v.id)
              } catch (error) {
                console.error('删除日历日程失败:', error)
              }
            })
          }
        }
      }
    },
    _formatTime(sTime, eTime) {
      const allDay = sTime.split(' ')[0]
      const day = `${Number(allDay.split('-')[1])}月${Number(
        allDay.split('-')[2]
      )}日`
      const time = `${sTime.slice(-8, -3)}-${eTime.slice(-8, -3)}`
      return `课程时间：${day} ${time}`
    },
    // 弹窗确定
    handleConfirm() {
      this.showPop = false
      // 确认取消约课按钮：进入页面，重新调用接口
      this.$toast.loading('取消预约中...')
      this.$http
        .delete2('index/ordered', {
          id:
            this.classInfo.member_appointment_id ||
            this.classInfo.memberappointmentid
        })
        .then((v) => {
          this.$toast.clear()
          if (v.data.msg === '预约的课程已确认取消') {
            // this.$toast('取消成功')
            this.$http.homeinfo('', '', this.$store.state.curCity.region_id)
            if (this.$betterwe.isApp()) {
              // 取消日历中的日程
              this.calendarChannelMethod()
            }
            this.doSuccess(v)
          } else {
            this.$toast.fail(v.data.msg)
            this.$emit('on-close')
          }
        })
        .catch((v) => {
          this.$toast.clear()
          this.$dialog.alert({ message: '取消失败，请重试' })
          this.$emit('on-close')
        })
    },
    // 取消约课成功逻辑
    doSuccess(v) {
      // 设置约课列表页面触发约课后缓存标记 刷新课程信息
      sessionStorage.setItem('loadHomeUpdate', true)
      // 触发成功回调，传递取消的课程信息
      this.$emit('on-success', v.data)
    },
    //  获取取消预约弹窗文案
    getCancelPopText() {
      try {
        console.log('====================================')
        console.log('classInfo', this.classInfo)
        console.log('====================================')
        if (
          !this.classInfo ||
          (!this.classInfo.start_time && !this.classInfo.starttime) ||
          !this.classInfo.updatetime
        ) {
          this.$http.get('member/index?a=shareLogPush', {
            from: `扫码取消约课失败-字段缺失-start_time:${
              this.classInfo && this.classInfo.start_time
            }-updatetime:${this.classInfo && this.classInfo.updatetime}`,
            from_id: 250702345
          })
          this.popType = 5
          return
        }
        // 兼容两种数据源：start_time 为日期字符串，starttime 为时间戳(秒)
        let stime = this.classInfo.start_time
          ? new Date(this.classInfo.start_time.replace(/-/g, '/')) / 1000
          : Number(this.classInfo.starttime)
        // 兼容 updatetime 为日期字符串或时间戳(秒)
        let ctime = isNaN(this.classInfo.updatetime)
          ? new Date(this.classInfo.updatetime.replace(/-/g, '/')) / 1000
          : Number(this.classInfo.updatetime)
        let now = Date.now() / 1000
        const date3 = Math.abs(stime * 1000 - Date.now())
        let days = Math.floor(date3 / (24 * 3600 * 1000)) + '天'
        let leave1 = date3 % (24 * 3600 * 1000)
        let hours = Math.floor(leave1 / (3600 * 1000))
        let leave2 = leave1 % (3600 * 1000)
        let minutes = Math.floor(leave2 / (60 * 1000))
        if (days[0] === '0') days = ''
        if (Math.abs(now - ctime) < 600) {
          // 10分钟内 不扣除经验值
          this.popType = 1
        } else {
          if (Math.abs(stime - now) < (60 + 55) * 60) {
            // 距离上课时间2小时以内 取消本次约课将扣除经验值20分
            this.popType = 2
          } else if (Math.abs(stime - now) < (60 * 3 + 55) * 60) {
            // 距离上课时间2小时以上 取消本次约课将扣除经验值5分
            this.popType = 3
          } else {
            // 本次取消在上课 前4小时 不扣除经验值
            this.popType = 4
          }
        }
      } catch (error) {
        this.$http.get('member/index?a=shareLogPush', {
          from: `扫码取消约课失败-getCancelPopText-${error && error.message}`,
          from_id: 250702345
        })
        this.popType = 5
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.CourseCancelPop {
  .pop-wrap {
    position: fixed;
    z-index: 21;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -55%);
    width: vw(295);
    box-sizing: border-box;
    padding: vw(16) vw(20);
    padding-bottom: vw(20);
    background: #ffffff;
    border-radius: vw(12);
    display: flex;
    flex-direction: column;
    align-items: center;
    .pop-title {
      font-weight: 600;
      font-size: vw(20);
      color: rgba($color: #000, $alpha: 0.8);
    }
    .pop-cent {
      font-size: vw(14);
      color: rgba($color: #000, $alpha: 0.8);
      margin-top: vw(14);
      text-align: left;
      line-height: vw(22);
      word-break: break-all;
      .bold-text {
        font-weight: 600;
      }
      .red-text {
        font-weight: 600;
        color: #dc0050;
      }
    }
    .pop-cent-center {
      text-align: center;
    }
    .pop-btn-wrap {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-top: vw(26);
      .pop-btn {
        width: vw(118);
        height: vw(44);
        box-sizing: border-box;
        background: #dc0050;
        border-radius: vw(22);
        box-shadow: 0px vw(1) vw(1) 0px rgba(0, 0, 0, 0.1);
        border-radius: 99px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: 600;
        font-size: vw(18);
        color: #ffffff;
      }
      .pop-btn-off {
        width: vw(118);
        height: vw(44);
        box-sizing: border-box;
        border-radius: vw(22);
        border: 1px solid #dc0050;
        background-color: transparent;
        font-weight: 550;
        font-size: vw(18);
        color: #dc0050;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}
</style>
